import {
  Certificates,
  Confirmation,
  Homepage,
  Payment,
  Quotes,
  Signature,
  Transaction,
} from '@/views/default';

import AccountsCompanies from '@/views/default/AccountsCompanies.vue';

import {
  DynamicModal,
  EmployeeTravelModal,
} from '@/views/modal';

import account from './account';
import claim from './claim';
import contracts from './contracts';
import documents from './documents';
import invoices from './invoices';
import perks from './perks';

const clientChildren = [
  {
    path: '',
    redirect: 'home',
    modal: DynamicModal,
  },
  {
    path: 'home',
    name: 'homepage',
    components: {
      default: Homepage,
      modal: DynamicModal,
    },
  },
  {
    path: 'accounts',
    name: 'accounts',
    components: {
      default: AccountsCompanies,
    },
  },
  { ...account },
  { ...claim },
  { ...contracts },
  { ...documents },
  { ...invoices },
  { ...perks },
  {
    path: 'certificates',
    name: 'clientCertificates',
    components: {
      default: Certificates,
      modal: EmployeeTravelModal,
    },
  },
  {
    path: 'confirmation',
    name: 'clientConfirmation',
    component: Confirmation,
  },
  {
    path: 'quotes',
    name: 'clientQuote',
    component: Quotes,
  },
  {
    path: 'payment/:id/:type?',
    name: 'clientPayment',
    component: Payment,
  },
  {
    path: 'transaction/:id',
    name: 'clientTransaction',
    component: Transaction,
  },
  {
    path: 'signature',
    name: 'clientSignature',
    components: {
      default: Signature,
      modal: DynamicModal,
    },
    meta: {
      disableBackButton: true,
    },
  },
];

export default clientChildren;
